<template>
  <div class="home-end-wrapper" :style="{backgroundImage: homeEndBg}">

    <div class="top-wrapper">

      <!-- 左侧logo图片 -->
<!--      <div class="logo-wrapper">-->
<!--        <img class="cute-icon" :src="source('cute')" alt="CUTE">-->
<!--        <gear-cute class="gear-icon" rotateReverse width="15.729vw" height="15.729vw"/>-->
<!--      </div>-->

      <!-- 左侧联系信息 -->
      <div class="contact-info-wrapper">
        <div class="email">E-MAIL：u-cutelab@ucute.space</div>
        <div class="tel">TEL：(86+)19180679521</div>
      </div>
      <div class="back-top-wrapper">
        <div class="back-top" ref="backTopRef" @click="toTop">BACK TO TOP</div>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="divider"/>

    <!-- 底部 -->
    <div class="copyright">Copyright @ Uber-cute interactive technology space. Ltd</div>
    <div class="beian"><a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2021021280号-1</a></div>
  </div>
</template>

<script>
import GearCute from "@/components/gear-cute.vue";
import key from "@/api/key";

export default {
  name: 'foot-bottom',
  components: { GearCute },
  data() {
    return {
      homeEndBg: `url(${this.source('foot-end-bg')})`,
    }
  },
  mounted() {
    const backTopEl = this.$refs.backTopRef
    const ob = new IntersectionObserver(e => {
      backTopEl.className = e[0].isIntersecting ? 'back-top animate__animated animate__flipInX' : 'back-top'
    })
    ob.observe(backTopEl)
  },
  methods: {
    toTop() {
      window.scrollTo({ top: 0, behavior: "smooth" })
    },
    source(name) {
      return key.getByName(key.COMMON, name).fileUrl
    },
  }
}
</script>

<style scoped lang="scss">
.home-end-wrapper {
  overflow: hidden;
  width: 100%;
  height: 41.5vw;
  background-color: black;
  background-repeat: no-repeat;
  background-size: cover;
  .bg-img{
    width: 100%;
    height: 112.5vw;
    position: absolute;
    top: -71vw;
    z-index: -1;
  }
  .top-wrapper {
    width: 91.667vw;
    position: relative;
    margin: 6.927vw auto 0 auto;
    display: flex;

    .logo-wrapper {

      .cute-icon {
        width: 37.135vw;
        height: 16.406vw;
      }

      .gear-icon {
        position: absolute;
        top: 9.583vw;
        left: 29.271vw;
      }
    }

    .contact-info-wrapper {
      width: 45.833vw;
      height: 10vw;
      margin-top: 15.521vw;
      font-size: 1.675vw;
      color: #FFFFFF;
      font-weight: 300;
      font-family: '微软雅黑';
      line-height: 1.667vw;

      .email {
        margin-top: 4.525vw;
      }

      .tel {
        margin-top: 1.125vw;
      }
    }

    .back-top-wrapper {
      width: 45.833vw;
      height: 10vw;
      margin-top: 15.521vw;
      font-size: 2.083vw;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.875vw;
      .back-top{
        float: right;
        position: relative;
        top: 7.5vw;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .divider {
    width: 91.667vw;
    height: 0.052vw;
    margin: 2.448vw auto 1.5625vw auto;
    background-color: rgba(255, 255, 255, .8);
  }

  .copyright {
    text-align: center;
    font-size: 1.667vw;
    color: #E6E6E6;
    font-weight: 300;
    font-family: '微软雅黑';
    line-height: 1.51vw;
  }

  .beian {
    margin-top: 0.5vw;
    text-align: center;
    font-size: 1.467vw;
    color: #E6E6E6;
    font-weight: 300;
    font-family: '微软雅黑';
    line-height: 1.467vw;
    a {
      color: #E6E6E6;
    }
  }
}
</style>
